export interface LocaleOption {
  code: string;
  name: string;
  flagUrl: string;
}

export const AvailableLocaleOptions: LocaleOption[] = [
  {
    code: 'en-US',
    name: 'English',
    flagUrl: 'assets/images/flags/flag-en-US.svg',
  },
  {
    code: 'ja-JP',
    name: '日本語',
    flagUrl: 'assets/images/flags/flag-ja-JP.svg',
  },
  {
    code: 'zh-CN',
    name: '简体中文',
    flagUrl: 'assets/images/flags/flag-zh-CN.svg',
  },
  {
    code: 'ko-KR',
    name: '한국어',
    flagUrl: 'assets/images/flags/flag-ko-KR.svg',
  },
  {
    code: 'th-TH',
    name: 'ภาษาไทย',
    flagUrl: 'assets/images/flags/flag-th-TH.svg',
  },
  {
    code: 'id-ID',
    name: 'Bahasa Indonesia',
    flagUrl: 'assets/images/flags/flag-id-ID.svg',
  },
  {
    code: 'vi-VN',
    name: 'Tiếng Việt',
    flagUrl: 'assets/images/flags/flag-vi-VN.svg',
  },
];
